
let _ = require('../_.js');
let $ = jQuery;

let registrant = null;

_.Notification_Force_Accept_Site_Terms = class Notification_Force_Accept_Site_Terms {

    static async init() {
        _.on_ui_update_once("#ac-modal-force-accept-site-terms-submit", function () {
            $(this).click(async function (e) {

                e.preventDefault();

                // Validate checkbox is checked before submitting
                if (!$("#force-form-user_accepted_terms").is(":checked")) {
                    _.apply_form_errors($("#ac-modal-force-accept-site-terms-modal-form"), { "user_accepted_terms": "You must agree to the Terms and Conditions to continue." });
                    return;
                }

                // Reset errors
                _.reset_form_errors($("#ac-modal-force-accept-site-terms-modal-form"));

                // Ajax submit
                try {
                    await _.backend_ajax('session', 'user_accepted_terms', { "user_accepted_terms": true });
                } catch (e) {
                    _.apply_form_errors($("#ac-modal-force-accept-site-terms-modal-form"), e);
                    return;
                }

                if (registrant) {
                    // Should prevent it from spawning more modals until the realtime record gets propigated
                    registrant.user_accepted_terms = true;
                }

                // Close the unhidable modal - this is the only way to dismiss the TOC modal
                await _.Modal.close_unhidable();

                await _.data_sync();
                await _.AuctionUI_Session.refresh(true);

                return;
            })
        });

        _.on_ui_update_once("#ac-modal-force-accept-site-terms-cancel", function () {
            $(this).click(async function (e) {
                e.preventDefault();
                await _.Modal.close_unhidable();
                if (registrant && registrant.user_accepted_terms == false) {
                    _.AuctionUI_Login.signout_clicked(false);
                }
            })
        });
    }

    // auction_round_id, bid_id, is_tie_bid = false) {
    static async show() {

        registrant = await _.AuctionUI_Session.get_registrant();

        if (!registrant) {
            console.log("Skipping TOC modal - no registrant");
            return;
        }

        // Reset form if it is not currently visible
        if (!$("#ac-modal-force-accept-site-terms-modal").is(":visible")) {
            $("#signup-form-user_accepted_terms").prop("checked", false);
            $("#ac-modal-force-accept-site-terms-modal").find(".invalid-feedback").hide();

            if (registrant.user_accepted_terms && registrant.terms_have_changed) {
                $("#ac-modal-force-accept-site-terms-new").hide();
                $("#ac-modal-force-accept-site-terms-updated").show();
            } else {
                $("#ac-modal-force-accept-site-terms-new").show();
                $("#ac-modal-force-accept-site-terms-updated").hide();
            }

            // Make this modal persistent and unclosable - critical for legal compliance
            // This prevents the notification system or any other code from dismissing this modal
            _.Modal.set_unhidable();

            $("#ac-modal-force-accept-site-terms-modal").modal_show();
        }
    }
}